import * as notificationTypes from '../types/Notification';
import * as modalTypes from '../types/Modal';
import * as pageTypes from '../types/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case notificationTypes.ADD_NOTIFICATION:
            return {
                ...state,
                message: action.notificationMessage,
                title: action.notificationTitle,
                type: action.notificationType
            };
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
        case modalTypes.SHOW_MODAL:
        case modalTypes.HIDE_MODAL:
        case notificationTypes.CLEAR_NOTIFICATION:
            return INITIAL_STATE;
    }
    return state;
}

const INITIAL_STATE = {
    message: '',
    title: '',
    type: null
};


// WEBPACK FOOTER //
// ./src/reducers/Notification.js